import React, { RefObject, useCallback, useEffect, useState } from 'react'
import { BottomSheetBackdrop, BottomSheetModal } from '@gorhom/bottom-sheet'
import { DS } from '../../../design-system'
import { Keyboard, Platform, StyleSheet, ActivityIndicator } from 'react-native'
import { MembershipTypes } from '../../../models/api-store'
import { ReduceMotion } from 'react-native-reanimated'

interface ConfirmUpdateProps {
  onSubmit: () => void
  bottomSheetModalRef: RefObject<BottomSheetModal | null>
  membershipType: MembershipTypes
  loading?: boolean
}

const ConfirmUpdate = ({ onSubmit, bottomSheetModalRef, membershipType, loading }: ConfirmUpdateProps) => {
  const [enableDismissOnClose, setEnableDismissOnClose] = useState(true)
  const onCancel = () => {
    bottomSheetModalRef.current?.close()
  }

  const renderBackdrop = useCallback(
    (props: React.ComponentProps<typeof BottomSheetBackdrop>) => (
      <BottomSheetBackdrop {...props} disappearsOnIndex={-1} appearsOnIndex={0} />
    ),
    []
  )

  useEffect(() => {
    if (Platform.OS !== 'android') return

    const keyboardDidShowListener = Keyboard.addListener('keyboardDidShow', () => setEnableDismissOnClose(false))
    const keyboardDidHideListener = Keyboard.addListener('keyboardDidHide', () => setEnableDismissOnClose(true))

    return () => {
      keyboardDidShowListener.remove()
      keyboardDidHideListener.remove()
    }
  }, [])

  return (
    <BottomSheetModal
      ref={bottomSheetModalRef}
      index={0}
      snapPoints={['30%']}
      backdropComponent={renderBackdrop}
      detached={false}
      keyboardBlurBehavior="restore"
      backgroundStyle={{ backgroundColor: DS.palette['Brand/Cream'] }}
      enableDismissOnClose={enableDismissOnClose}
      overrideReduceMotion={ReduceMotion.System}
    >
      <DS.Frame style={styles.container}>
        <DS.Frame style={styles.titleContainer}>
          <DS.Text variant="Heading 2/Medium">Confirm Upgrade</DS.Text>
        </DS.Frame>
        <DS.Frame style={styles.buttonContainer}>
          <DS.Button variant="Large/Primary" onPress={onSubmit} type={'On Light'} disabled={loading}>
            {membershipType === 'silver' ? 'Upgrade to Gold' : 'Downgrade to Silver'}
            {loading && <ActivityIndicator style={styles.loadingIndicator} size="small" />}
          </DS.Button>
          <DS.Button textColor="Global/Black" variant="Large/Secondary" onPress={onCancel} type={'On Light'}>
            Cancel
          </DS.Button>
        </DS.Frame>
      </DS.Frame>
    </BottomSheetModal>
  )
}

const styles = StyleSheet.create({
  container: {
    padding: 16
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%'
  },
  buttonContainer: {
    marginTop: 16,
    width: '100%',
    gap: 8,
    paddingHorizontal: 24
  },
  loadingIndicator: {
    marginLeft: 16
  }
})
export default ConfirmUpdate
